import { useState } from 'react';
import VsimavecHead from '../../assets/vsimavec-head.svg';
import Kalkulacka from '../../assets/kalkulacka.png';
import Tabule from '../../assets/tabule.png';
import { Button } from '../buttons/Button';
import { AgeBand } from '../../lib/plan/types';
import { cn } from '../../lib/helpers';

interface AgeBandStepProps {
    onSelect: (band: AgeBand) => void;
}

const AGE_BANDS: {
    id: AgeBand;
    label: string;
    image: string;
}[] = [
    { id: '1_3', label: '1. – 3. třída', image: Tabule },
    { id: '4_5', label: '4. – 5. třída', image: Kalkulacka },
];

export function AgeBandStep({ onSelect }: AgeBandStepProps) {
    const [selected, setSelected] = useState<AgeBand>(AGE_BANDS[0].id);

    return (
        <div className="flex flex-col items-center text-center">
            {/* Header */}
            <div className="mb-8 w-20">
                <img
                    src={VsimavecHead}
                    alt="Všímavec"
                    className="h-full w-full object-contain"
                />
            </div>
            <h1 className="text-5xl">Pro jaký ročník sestavujeme plán?</h1>
            <p className="mt-3 text-ink-800">
                Podle ročníku přizpůsobíme dotazník i doporučená cvičení.
            </p>

            {/* Age band selection */}
            <div className="mt-10 grid w-full max-w-xl grid-cols-1 gap-4 sm:grid-cols-2">
                {AGE_BANDS.map((band) => {
                    const isSelected = band.id === selected;
                    return (
                        <button
                            key={band.id}
                            type="button"
                            onClick={() => setSelected(band.id)}
                            className={cn(
                                'flex flex-col items-center gap-3 rounded-2xl border-2 bg-white p-8 text-center transition-all duration-150',
                                isSelected
                                    ? 'scale-[1.02] border-product-500 shadow-md'
                                    : 'border-cloud-300 hover:border-product-300 hover:shadow-sm'
                            )}
                        >
                            {/* Obrázek je dekorativní — název ročníku pod ním
                                nese stejnou informaci, proto prázdný alt. */}
                            <img
                                src={band.image}
                                alt=""
                                className={cn(
                                    'h-20 w-auto object-contain transition-opacity',
                                    isSelected ? 'opacity-100' : 'opacity-60'
                                )}
                            />
                            <span className="text-xl font-semibold text-ink-900">
                                {band.label}
                            </span>
                        </button>
                    );
                })}
            </div>

            {/* Button */}
            <div className="mt-10 flex w-full max-w-sm flex-col">
                <Button
                    color="product"
                    className="text-base"
                    onClick={() => onSelect(selected)}
                >
                    Pokračovat k dotazníku
                </Button>
            </div>
        </div>
    );
}
